export default "__VITE_ASSET__Cf9Pfi8o__"